// External
import React from "react";

// Nvidia
import { KaizenThemeProvider, KaizenThemes } from "@kaizen-ui/styles";

// Local
import "./App.css";
import { Search } from "./routes/search";

function App(): JSX.Element {
    // @NOTE: Search is loaded here by default as the omni-doc search only currently
    // has that ability. If additional routes are required, then redirecting here
    // to the desired "default" view would be more appropriate and routes should
    // be specified in index.tsx.
    return (
        <div
            style={{
                padding: KaizenThemes.enterpriseDark.spacing.zero,
                paddingRight: "0em",
            }}
        >
            <KaizenThemeProvider themeName="enterpriseLight">
                <Search />
            </KaizenThemeProvider>
        </div>
    );
}

export default App;
